import { getCurrencySymbol } from '@vy/services';
import type { Currency } from '@vy/types';
import { formatNumberWithPrecision } from '../../utils/number';

export function getFormattedNumberWithCurrencySymbol(
  currency: Currency,
  number: number,
  precision?: number,
): string {
  return `${formatNumberWithPrecision(number, precision ?? 2)}${getCurrencySymbol(currency)}`;
}
